var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h80v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.375 0 30.5 22.625L70.25 0H80v7.75L50 30.125l30 22.25V60H70L40 37.625 10.125 60H0v-7.5l29.875-22.25L0 8V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M53 35.125 80 55v5L46.125 35.125zm-23 2.5L30.75 42l-24 18H0zM80 0v.375l-31.125 23.5.25-5.5L73.75 0zM0 0l29.875 22h-7.5L0 5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.125 0v60h20V0zM0 20v20h80V20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 24.125v12h80v-12zM34.125 0v60h12V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    fill: "#fff",
    rx: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/ukFlag.76b8b4482cfb233d232d2e9fd9b7abab.svg";
export { ForwardRef as ReactComponent };